
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-345 143 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"-907.592","y1":"305.399","x2":"-907.613","y2":"305.351","gradientTransform":"matrix(240 0 0 -240 217490 73442)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#37aee2"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#1e96c8"}})]),_c('circle',{attrs:{"cx":"-335","cy":"153","r":"10","fill":"url(#a)"}}),_c('path',{attrs:{"d":"M-336.8 157.6c-.3 0-.3-.1-.4-.4l-1-3.1 7.3-4.4","fill":"#c8daea"}}),_c('path',{attrs:{"d":"M-336.8 157.6c.2 0 .4-.1.5-.2l1.3-1.3-1.7-1","fill":"#a9c9dd"}}),_c('linearGradient',{attrs:{"id":"b","gradientUnits":"userSpaceOnUse","x1":"-905.963","y1":"305.278","x2":"-905.947","y2":"305.247","gradientTransform":"matrix(130.4927 0 0 -109.4496 117887.313 33565.758)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#eff7fc"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff"}})]),_c('path',{attrs:{"d":"M-336.7 155l4 3c.5.3.8.1.9-.4l1.6-7.7c.2-.7-.3-1-.7-.8l-9.6 3.7c-.7.3-.7.6-.1.8l2.5.8 5.7-3.6c.3-.2.5-.1.3.1","fill":"url(#b)"}})])
          )
        }
      }
    